import React from "react";

import Grid from "@material-ui/core/Grid";
import useMediaQuery from "@material-ui/core/useMediaQuery";

import photo from "../../static/images/photo.png";

import TopLeftCorner from "../../shared-components/TopLeftCorner";
import TopRightCorner from "../../shared-components/TopRightCorner";
import BottomLeftCorner from "../../shared-components/BottomLeftCorner";
import BottomRightCorner from "../../shared-components/BottomRightCorner";

const About = () => {
  const matchesSm = useMediaQuery("(max-width:960px)");

  return (
    <Grid container style={{ padding: "2.5rem", color: "#EEEEEE" }}>
      <Grid item>
        <TopLeftCorner />
        <Grid container alignItems="flex-end" style={{ height: "92.5%" }}>
          <BottomLeftCorner />
        </Grid>
      </Grid>

      <Grid item lg md sm xs style={{ margin: "3rem 0" }}>
        <h1 style={{ marginBottom: "5rem" }} className="about-tagline">
          Hi! I am{" "}
          <span
            style={{
              padding: "0.2rem 0.5rem 0.3rem",
              color: "#222831",
              backgroundColor: "#EEEEEE",
            }}
          >
            Kaustubh Padwal
          </span>
        </h1>

        <h1 className="content-title-1" style={{ marginBottom: "2.5rem" }}>
          <span
            style={{
              color: "#EEEEEE",
              borderBottom: "6px solid #EEEEEE",
              paddingBottom: "1rem",
            }}
          >
            # Who am I?
          </span>
        </h1>

        <div style={{ width: "100%", marginBottom: "5rem" }}>
          <h2 style={{ lineHeight: "3.5rem" }} className="content-1">
            I am a{" "}
            <span
              style={{
                padding: "0.2rem 0.5rem 0.3rem",
                color: "#222831",
                backgroundColor: "#EEEEEE",
              }}
            >
              frontend developer
            </span>{" "}
            who is well versed in modern javascript frameworks and libraries and
            ready to solve new challenges.
          </h2>
        </div>

        <h1 className="content-title-2" style={{ marginBottom: "2.5rem" }}>
          <span
            style={{
              color: "#EEEEEE",
              borderBottom: "6px solid #EEEEEE",
              paddingBottom: "1rem",
            }}
          >
            # What I do?
          </span>
        </h1>

        <div style={{ width: "100%" }}>
          <Grid container>
            <Grid item lg={8} md={8} sm={12} xs={12}>
              <h2 style={{ lineHeight: "3.5rem" }} className="content-2">
                I create <span style={{ color: "#80FF6C" }}>accessible</span>{" "}
                and <span style={{ color: "#80FF6C" }}>responsive</span>{" "}
                <span style={{ color: "#FFC226" }}>websites</span> and{" "}
                <span style={{ color: "#FFC226" }}>web applications</span> using
                the latest technologies like{" "}
                <span style={{ color: "#FAFF00" }}>
                  React, Redux, Javascript (ES6+)
                </span>{" "}
                and various UI libraries like{" "}
                <span style={{ color: "#FAFF00" }}>
                  Material UI, React Suite,
                </span>{" "}
                etc.
              </h2>
            </Grid>
            <Grid
              item
              lg={4}
              md={4}
              sm={12}
              xs={12}
              style={
                matchesSm
                  ? { textAlign: "center", margin: "2rem" }
                  : { textAlign: "right" }
              }
            >
              <img
                src={photo}
                alt="profile"
                style={
                  matchesSm
                    ? {
                        height: "12rem",
                        width: "12rem",
                        border: "6px solid #EEEEEE",
                      }
                    : {
                        height: "14rem",
                        width: "14rem",
                        border: "6px solid #EEEEEE",
                      }
                }
                className="photo"
              />
            </Grid>
          </Grid>
        </div>
      </Grid>

      <Grid
        item
        style={matchesSm ? { display: "none" } : { margin: "7.5rem 0" }}
      >
        <TopRightCorner color="#A1A5FF" animate="corner-3" />
      </Grid>

      <Grid item style={matchesSm ? { display: "none" } : { margin: "5rem 0" }}>
        <TopRightCorner color="#FFE665" animate="corner-2" />
      </Grid>

      <Grid
        item
        style={matchesSm ? { display: "none" } : { margin: "2.5rem 0 " }}
      >
        <TopRightCorner color="#5FEAFD" animate="corner-1" />
      </Grid>

      <Grid item>
        <TopRightCorner />
        <Grid container alignItems="flex-end" style={{ height: "92.5%" }}>
          <BottomRightCorner />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default About;
